import { useState, useEffect, useCallback } from 'react'

function useCrawlingTags(isApplicable = false) {
  const [currentTags, setCurrentTags] = useState({
    robotsTag: null,
    canonicalTag: null,
  })

  useEffect(() => {
    const canonical = getCanonicalTag()
    const robots = getRobotsTag()

    if (
      currentTags.canonicalTag === null
      && currentTags.robotsTag === null
    ) {
      setCurrentTags({
        robotsTag: !!robots,
        canonicalTag: !!canonical,
      })
    }
  }, [])

  const updateState = () => {
    setCurrentTags({
      canonicalTag: !!getCanonicalTag(),
      robotsTag: !!getRobotsTag(),
    })
  }

  const getCanonicalTag = () => {
    return document.querySelector('link[rel="canonical"]')
  }

  const getRobotsTag = () => {
    return document.querySelector('meta[name="robots"]')
  }

  const addCanonicalTag = useCallback((url) => {
    if (!isApplicable) {
      return null
    }

    const link = document.createElement('link')

    link.setAttribute('rel', 'canonical')
    link.setAttribute('href', url)
    document.head.appendChild(link)
    updateState()
  }, [isApplicable])

  const removeCanonicalTag = useCallback(() => {
    if (!isApplicable) {
      return null
    }

    getCanonicalTag()?.remove()
    return updateState()
  }, [isApplicable])

  const addRobotsTag = useCallback(() => {
    if (!isApplicable) {
      return null
    }

    const meta = document.createElement('meta')

    meta.setAttribute('name', 'robots')
    meta.setAttribute('content', 'noindex, follow')
    document.head.appendChild(meta)
    return updateState()
  }, [isApplicable])

  const removeRobotsTag = useCallback(() => {
    if (!isApplicable) {
      return null
    }

    getRobotsTag()?.remove()
    return updateState()
  }, [isApplicable])

  const adjustCanonicalTag = useCallback((newHref) => {
    if (isApplicable) {
      return null
    }

    const canonical = getCanonicalTag()

    if (canonical) {
      canonical.setAttribute('href', newHref)
    }
  }, [])

  return {
    hasCanonicalTag: currentTags.canonicalTag,
    hasRobotsTag: currentTags.robotsTag,
    addCanonicalTag,
    removeCanonicalTag,
    addRobotsTag,
    removeRobotsTag,
    adjustCanonicalTag,
  }
}

export { useCrawlingTags }
